<script lang="ts">
    import src from './svg/stylus_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let title: string = '';

    let styleElement = 'width:20px; height:20px;';
</script>

<TemplateIcon {src} {scale} alt={title} hover={title} on:click {styleElement} />
